import React, { Component } from 'react';
import OtpField from '../../UI/otpField/otpField';
import OtpTimer from '../../UI/OtpTimer/OtpTimer';
import { errorCode, errorMsg } from '../../../ErrorCode/ErrorCode';
import mixpanelService from '../../Services/mixpanelService';
import mixpanelEvents, { getScreenName } from '../../../config/mixpanelEvents';
import './RegOtp.scss'

interface IRegOtpProps {
    label: string;
    otpTimer: number;
    eleId: string;
    onChange: (value: string) => string | void;
    resendClicked: () => string | void;
    disableOtp?: boolean;
    invalidOtp?: boolean;
}

let resendTimer: any;

class RegOtp extends Component<IRegOtpProps> {
    resendTimer: any;

    state = {
        otp: '',
        isResend: false,
        timer: this.props.otpTimer
    };

    enableClock = () => {
        this.resendTimer = setInterval(() => {
            this.setState((prevState: any) => {
                let temp = prevState.timer - 1;

                if (temp === 0) {
                    clearInterval(this.resendTimer);
                    return { timer: this.props.otpTimer, isResend: true };
                }

                return { timer: temp };
            });
        }, 1000);
    };

    componentDidMount() {
        this.enableClock();
    }

    componentWillUnmount() {
        clearInterval(this.resendTimer);
    }

    setOtp = (value: any) => {
        this.setState({ otp: value });
        this.props.onChange(value);
    };

    resendClicked = () => {
        try {
            const screen_name = getScreenName(window.location.pathname);
            if (screen_name) {
                mixpanelService({
                    event: mixpanelEvents.CTA_CLICKED,
                    screen_name,
                    text: "Resend now",
                    cta_type: "sticky",
                    cta_class: "secondary",
                    cta_service: "AOJ",
                });
            }
        } catch (e) {
            console.error("mixpanel cta_clicked failed", e);
        }

        clearInterval(this.resendTimer); // ✅ clear previous timer
        this.setState({ isResend: false, timer: this.props.otpTimer });
        this.props.resendClicked();

        setTimeout(() => this.enableClock(), 500);
    };

    render() {
        const otpLabelId = `${this.props.eleId}-otp-label`;
        const otpErrorId = `${this.props.eleId}-otp-error`;
        return (
            <div className='regOtp'>
                <p className='otpLbl' id={otpLabelId}>{this.props.label}</p>

                <div className='otpInput'>
                    <OtpField
                        onChange={(value) => this.setOtp(value)}
                        eleId={this.props.eleId}
                        disableOtp={this.props.disableOtp}
                        invalidOtp={this.props.invalidOtp}
                        ariaLabelledBy={otpLabelId}
                        ariaDescribedBy={this.props.invalidOtp ? otpErrorId : undefined}
                    />

                    {this.props.invalidOtp && (
                        <p className='incrtOtp' id={otpErrorId} role="alert" aria-live="assertive">
                            {errorMsg(errorCode.FE05)}
                        </p>
                    )}
                </div>

                {this.state.isResend ? (
                    <div className='resendOtpText'>
                        <span className='otpNotRecv'>Didn't receive the OTP?</span>
                        <button type='button' className='resendOtpLink' onClick={this.resendClicked}>
                            Resend now
                        </button>
                    </div>
                ) : (
                    <div className='otpTimer'>
                        <OtpTimer timer={this.state.timer} />
                    </div>
                )}
            </div>
        );
    }
}

export default RegOtp